import {theme} from '../../theme';
import {propertyToVariant, VariantProps} from '../variant-utilities';

export const shadow = {
  ...propertyToVariant('boxShadow', theme.shadows),
};

export type ShadowProps = VariantProps<typeof shadow>;
